export default __webpack_public_path__ + "static/media/announcement_3.8a83fef9.png";